import React from "react";
import { Container, Col, Row } from "react-bootstrap";

function Education() {
  return (
    <Container fluid>
      <Row style={{ justifyContent: "center" }}>
        <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
          <strong className="purple">Education</strong>
        </h1>
        <Col
          md={8}
          style={{
            justifyContent: "center",
            paddingBottom: "50px",
          }}
        >
          <blockquote className="blockquote ">
            <p style={{ textAlign: "left" }}>
              National Institute of Technology Jamshedpur
              <span className="purple"></span>
              <br />
              <br />
              Bachelors of Technology &#40; B.Tech &#41;
              <br />
              Electrical Engineering
              <br />
            </p>
          </blockquote>
        </Col>
        <Col
          md={4}
          style={{
            justifyContent: "center",
            padding: "40px",
          }}
        >
          <blockquote className="blockquote mb-0">
            <p style={{ textAlign: "justify" }}>
              2020 - 2024
              <br />
            </p>
          </blockquote>
        </Col>
      </Row>
    </Container>
  );
}

export default Education;
